import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMap, faTrashArrowUp, faRefresh } from '@fortawesome/free-solid-svg-icons'
import CodeEditorModal from '../pages/modals/CodeEditorModal'
import TestDataModal from '../pages/modals/TestDataModal'
import NotificationBanner from './elements/NotificationBanner'
import LoanCalculatorModal from '../pages/modals/LoanCalculatorModal'
import AddNoteModal from '../pages/modals/AddNoteModal'
import ConfirmModal from '../pages/modals/customer_service/ConfirmModal'
import MakeUpPaymentModal from '../pages/modals/customer_service/MakeUpPaymentModal'
import PayDownModal from '../pages/modals/customer_service/PayDownModal'
import PayOffModal from '../pages/modals/customer_service/PayOffModal'
import AdjustScheduleModal from '../pages/modals/customer_service/AdjustScheduleModal'
import DeleteRecordModal from '../pages/modals/DeleteRecordModal'
import UploadModal from '../pages/modals/customer_service/UploadModal'
import ACHRevocationModal from '../pages/modals/customer_service/ACHRevocationModal'
import AllowACHPaymentsModal from '../pages/modals/AllowACHPaymentsModal'
import Logo from '../assets/lendox_logo_white.svg'
import WithdrawLeadModal from '../pages/modals/customer_service/WithdrawLeadModal'
import ScheduleCallbackModal from '../pages/modals/customer_service/ScheduleCallbackModal'
import DeceasedModal from '../pages/modals/customer_service/DeceasedModal'
import WaiveModal from '../pages/layouts/payment_schedule/WaiveModal'
import VoidLoanModal from '../pages/layouts/payment_schedule/VoidLoanModal'
import EditPaymentModal from '../pages/layouts/payment_schedule/EditPaymentModal'
import PreferredCommunicationsModal from '../pages/modals/customer_service/PreferredCommunicationsModal'
import CeaseDesistModal from '../pages/modals/customer_service/CeaseDesistModal'
import { setModal } from '../redux/modalSlice'
import LendoxLegendModal from '../pages/modals/LendoxLegendModal'
import PowerOfAttorneyModal from '../pages/modals/customer_service/PowerOfAttorneyModal'
import DmcModal from '../pages/modals/customer_service/DmcModal'
import { selectUser } from '../redux/userSlice'
import PreviewTemplateModal from "../pages/modals/PreviewTemplateModal";
import ReportArgumentModal from "../pages/modals/ReportArgumentModal";
import CustomerSearchModal from '../pages/modals/customer_service/CustomerSearchModal'
import EncryptedFieldChallengeModal from '../pages/modals/customer_service/EncryptedFieldChallengeModal'
import BankruptcyMonitoringModal from '../pages/modals/customer_service/BankruptcyAttorneyInformationModal'
import BankruptcyFinalizeConfirmationModal from '../pages/modals/customer_service/BankruptcyFinalizeConfirmationModal'
import { ManagerApprovalParentModal } from '../pages/modals/manager_approval/ManagerApprovalParentModal'
import PaymentEntryModal from '../pages/modals/check_entry/PaymentEntryModal'
import ExpressLoanModal from "../pages/modals/customer_service/ExpressLoanModal";
import AlertModal from "../pages/modals/AlertModal";
import ChangePaymentMethodModal from '../pages/modals/loan_service/ChangePaymentMethodModal'
import CustomerDetailsModal from '../pages/modals/customer_service/CustomerDetailsModal'
import LeadDetailsModal from '../pages/modals/customer_service/LeadDetailsModal'
import WireApprovalModal from "../pages/modals/WireApprovalModal";
import CustomerSsnModal from "../pages/modals/customer_service/CustomerSsnModal";
import CustomerSearchCheckEntryModal from "../pages/modals/CustomerSearchCheckEntryModal";
import BankAccountModal from "../pages/modals/customer_service/BankAccountModal";
import DebitCardModal from "../pages/modals/customer_service/DebitCardModal";
import CustomerResendEmailModal from "../pages/modals/customer_service/CustomerResendEmailModal";
import DeleteBureauTradelineModal from "../pages/modals/customer_service/DeleteBureauTradelineModal";
import CancelLoanModal from "../pages/modals/customer_service/CancelLoanModal";
import RedeemForPaydownModal from "../pages/modals/customer_service/RedeemForPaydownModal";
import RewardAuditLogModal from "../pages/modals/customer_service/RewardAuditLogModal";
import ResolutionAmountModal from '../pages/modals/loan_service/ResolutionAmountModal'
import IdentityTheftModal from "../pages/modals/customer_service/IdentityTheftModal";
import CancelRefinanceModal from '../pages/modals/customer_service/CancelRefinanceModal'
import UnholdPaymentModal from '../pages/modals/payment_schedule/UnholdPaymentModal'
import CampaignTestRunResultModal from '../pages/modals/campaign/CampaignTestRunResultModal'
import UnholdPaymentsModal from '../pages/modals/loan_service/UnholdPaymentsModal'
import PortfolioDetailsModal from '../pages/modals/customer_service/PortfolioDetailsModal'
import CashOutRefinanceEligibilityModal from '../pages/modals/customer_service/CashOutRefinanceEligibilityModal'
import NoCashOutRefinanceEligibilityModal from '../pages/modals/customer_service/NoCashOutRefinanceEligibilityModal'
import DSDeniedModal from '../pages/modals/customer_service/DSDeniedModal'
import RefinanceCashOutModal from '../pages/modals/customer_service/RefinanceCashOutModal'
import CollectionRefinanceModal from '../pages/modals/customer_service/CollectionRefinanceModal'
import SensitivePiiViewModal from '../pages/modals/customer_service/SensitivePiiViewModal'
import BankLoginsModal from '../pages/modals/customer_service/BankLoginsModal'
import CallNoteModal from "../pages/modals/CallNoteModal";
import PayrollAmountConfirmationModal from '../pages/modals/customer_service/PayrollAmountConfirmationModal'
import { selectSimulatedDate } from '../redux/simulatedDateSlice'
import { FormatDateTimeToSame } from '../helpers/formatting'
import TranscriptNoteModal from "../pages/modals/TranscriptNoteModal";

export function Footer() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const active = useSelector(selectUser)
  const simulatedDate = useSelector(selectSimulatedDate)
  const [userPermissions, setUserPermissions] = useState([])

  /**
  * Check if the user has correct permissions
  */
  useEffect(() => {
    if (active.status === 'succeeded' && module) {
      const activePermissions = active.spoofed_user.user_permission_options ? active.spoofed_user.user_permission_options : active.data.user_permission_options
      setUserPermissions(activePermissions)
    }
  }, [active])

  function clearRootCache() {
    localStorage.removeItem('persist:root')
    navigate(0)
  }

  return (
    <footer>
      <div
        className={`${process.env.REACT_APP_ENVIRONMENT !== 'production' ? 'dev-env-color' : ''} lox-static-footer has-background-primary is-flex is-justify-content-space-between is-align-items-center px-3 py-1`}
      >
        <div className="is-flex is-align-items-center">
          <FontAwesomeIcon
            className="has-text-white is-size-5 is-clickable mr-3"
            icon={faTrashArrowUp}
            onClick={() => clearRootCache()}
          />
          <Link
            className="lox-static-footer_full-logo--link pt-1"
            to={'/home'}
            title="LendOx"
          >
            <img src={Logo} alt="LendOx full icon" />
          </Link>
        </div>
        <div className="is-flex is-align-items-center">
          <div className="is-flex is-align-items-center is-flex-direction-column has-text-white has-text-weight-bold mr-5">
            <p>All Dates/Times in:</p>
            <p>America/Phoenix</p>
          </div>
          {process.env.REACT_APP_ENVIRONMENT !== 'production' && simulatedDate?.simulated_date && (
            <div className="is-flex is-align-items-center mr-3">
              <span className="tag is-warning has-text-weight-bold">
                Spoof: {FormatDateTimeToSame(simulatedDate.simulated_date, 'MM/dd/yyyy hh:mm:ss a')}
              </span>
              {simulatedDate.needsRefresh && (
                <button
                  className="button is-small is-link ml-2 has-tooltip-arrow has-tooltip-top has-tooltip-primary"
                  data-tooltip="Spoof date changed - refresh page"
                  onClick={() => window.location.reload()}
                >
                  <FontAwesomeIcon icon={faRefresh} />
                </button>
              )}
            </div>
          )}
          <div className="is-flex is-align-items-center">
            <FontAwesomeIcon
              className="has-text-white is-size-5 is-clickable mr-3"
              icon={faMap}
              onClick={() => {
                dispatch(setModal({ title: `LendOx Legend`, type: 'lendox_legend', is_active: true }))
              }}
            />
          </div>
        </div>
      </div>
      <div style={{ padding: '3rem 1.5rem 6rem' }}>
        {/* TODO: Continue adding modals here, ultimately I think I want to get rid of the type part of the Modal Redux
              and instead have variables for content, height and width values so that the base modal styling is
              part of a modal.jsx file that is controller by the is_active flag and each modal content just gets loaded
              into that base modal */}
        {/* EX: <Modal /> */}
        <CodeEditorModal />
        <TestDataModal />
        <CallNoteModal />
        <TranscriptNoteModal />
        <LoanCalculatorModal key="calculator" />
        <DeleteRecordModal />
        <AdjustScheduleModal />
        <BankAccountModal />
        <ConfirmModal />
        <CustomerDetailsModal />
        <LeadDetailsModal />
        <CustomerSsnModal />
        <CustomerResendEmailModal />
        <DebitCardModal />
        <AddNoteModal />
        <MakeUpPaymentModal />
        <PayDownModal />
        <PayOffModal />
        <ACHRevocationModal />
        <AllowACHPaymentsModal />
        <UploadModal />
        <WithdrawLeadModal />
        <ScheduleCallbackModal />
        <DeceasedModal />
        <CeaseDesistModal />
        <WaiveModal />
        <VoidLoanModal />
        <EditPaymentModal />
        <PreferredCommunicationsModal />
        <PowerOfAttorneyModal />
        <DmcModal />
        <PreviewTemplateModal />
        <ReportArgumentModal />
        <CustomerSearchModal />
        <CustomerSearchCheckEntryModal />
        <ExpressLoanModal />
        <EncryptedFieldChallengeModal />
        <BankruptcyMonitoringModal />
        <BankruptcyFinalizeConfirmationModal />
        <ManagerApprovalParentModal />
        <PaymentEntryModal />
        <ChangePaymentMethodModal />
        <AlertModal />
        <WireApprovalModal />
        <DeleteBureauTradelineModal />
        <CancelLoanModal />
        <RedeemForPaydownModal />
        <RewardAuditLogModal />
        <ResolutionAmountModal />
        <IdentityTheftModal />
        <CancelRefinanceModal />
        <UnholdPaymentModal />
        <CampaignTestRunResultModal />
        <UnholdPaymentsModal />
        <PortfolioDetailsModal />
        <CashOutRefinanceEligibilityModal />
        <DSDeniedModal />
        <NoCashOutRefinanceEligibilityModal />
        <CollectionRefinanceModal />
        <RefinanceCashOutModal />
        <SensitivePiiViewModal />
        <BankLoginsModal />
        <PayrollAmountConfirmationModal />
      </div>
      <LendoxLegendModal />

      <div>
        <NotificationBanner />
      </div>
    </footer>
  )
}
